import { Geolocation } from "@capacitor/geolocation";
import axios from "axios";

export default {
  state: {
    watcherId: null,
    menuIconColor: "blue",
    filters: {
      category: null,
      area: null,
    },

    insets: null,
    languages: [
      {
        name: "Ελληνικά",
        engName: "Greek",
        code: "el",
      },

      {
        name: "English",
        engName: "English",
        code: "en",
      },
    ],

    location: {
      latitude: 0,
      longitude: 0,
    },

    mobileLang: JSON.parse(localStorage.getItem("mobileLang")) || null,
  },

  mutations: {
    setMenuIconColor(state, menuIconColor) {
      state.menuIconColor = menuIconColor;
    },

    setWatcherId(state, watcherId) {
      state.watcherId = watcherId;
    },

    getLocation(state, location) {
      state.location = location;
    },

    setInsets(state, insets) {
      state.insets = insets;
    },

    setMobileLang(state, lang) {
      if (typeof lang == "string") {
        const langObj = state.languages.find((el) => el.code == lang);
        state.mobileLang = langObj;
        localStorage.setItem("mobileLang", JSON.stringify(langObj));
      } else {
        state.mobileLang = lang;
        localStorage.setItem("mobileLang", JSON.stringify(lang));
      }
      axios.defaults.headers.common[
        "Accept-Language"
      ] = `${state.mobileLang.code}`;
    },
  },

  actions: {
    async getLocation({ commit }) {
      try {
        await Geolocation.watchPosition(
          {
            enableHighAccuracy: true,
            timeout: 6000,
            maximumAge: 600,
          },
          (data) => {
            console.log(data);
            commit("getLocation", {
              latitude: data.coords.latitude,
              longitude: data.coords.longitude,
            });
          }
        );
      } catch (e) {
        console.log(e);
      }
    },
  },
};
